<template>
  <div class="schema-field-list">
    <v-expansion-panels v-if="fields.length > 0" multiple focusable>
      <schema-field-panel
        v-for="(field, idx) in fields"
        :key="field._uid || idx"
        :field="field"
        :sibling-fields="fields"
        :fieldset-options="fieldsetItems"
        :cms-types="cmsTypes"
        :fragment-types="fragmentTypes"
        :is-top-level="isTopLevel"
        :is-first="idx === 0"
        :is-last="idx === fields.length - 1"
        @update="onFieldUpdate(idx, $event)"
        @move-up="moveField(idx, -1)"
        @move-down="moveField(idx, 1)"
        @duplicate="duplicateField(idx)"
        @remove="removeField(idx)"
        @edit-nested="$emit('edit-nested', idx)"
      />
    </v-expansion-panels>
    <div v-else class="text-center grey--text py-6">
      No fields yet. Click "Add Field" to get started.
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import SchemaFieldPanel from './SchemaFieldPanel'
import { reassignUids } from './schemaUtils'

export default {
  components: {
    SchemaFieldPanel,
  },
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    fieldsets: {
      type: Array,
      default: () => [],
    },
    cmsTypes: {
      type: Array,
      default: () => [],
    },
    fragmentTypes: {
      type: Array,
      default: () => [],
    },
    isTopLevel: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    fieldsetItems() {
      return this.fieldsets.map(fs => ({
        text: fs.label || fs.key,
        value: fs.key,
      }))
    },
  },
  methods: {
    onFieldUpdate(idx, updated) {
      const fields = cloneDeep(this.fields)
      fields[idx] = updated
      this.$emit('update', fields)
    },
    moveField(idx, direction) {
      const newIdx = idx + direction
      if (newIdx < 0 || newIdx >= this.fields.length) {
        return
      }
      const fields = cloneDeep(this.fields)
      const temp = fields[idx]
      fields[idx] = fields[newIdx]
      fields[newIdx] = temp
      this.$emit('update', fields)
    },
    duplicateField(idx) {
      const fields = cloneDeep(this.fields)
      const dup = reassignUids(cloneDeep(fields[idx]))
      dup.key = dup.key + '_copy'
      fields.splice(idx + 1, 0, dup)
      this.$emit('update', fields)
    },
    removeField(idx) {
      const fields = cloneDeep(this.fields)
      fields.splice(idx, 1)
      this.$emit('update', fields)
    },
  },
}
</script>
